<template>
  <cx-color-picker
    class="flex1"
    :isThemeColor.sync="isThemeColorVal"
    :colorArr.sync="colorVal"
  >
  </cx-color-picker>
<!--  <div ref="component" class="color-picker-container custom-text-bg">-->
<!--    <el-color-picker-->
<!--      v-if="isThemeColorVal"-->
<!--      v-model="themeColor"-->
<!--      color-format="rgb"-->
<!--      :show-alpha="true"-->
<!--      :disabled="isThemeColorVal"-->
<!--    ></el-color-picker>-->
<!--    <el-color-picker v-else v-model="colorVal" color-format="rgb" :show-alpha="true" @active-change="activeChangeColor"></el-color-picker>-->
<!--    <span v-if="isThemeColorVal" class="floatLeft color-text mr8">主题色</span>-->
<!--    <span v-else class="floatLeft color-text mr8">{{ colorVal }}</span>-->
<!--    <el-tooltip-->
<!--      class="item"-->
<!--      effect="dark"-->
<!--      :open-delay="tooltipDelay"-->
<!--      :content="isThemeColorVal ? '解除绑定' : '绑定主题色'"-->
<!--      placement="top"-->
<!--    >-->
<!--      <span-->
<!--        @click="changeColorType"-->
<!--        class="input-icon bind-icon right-handle-icon"-->
<!--        :class="isThemeColorVal ? 'icon-portal-unbind' : 'icon-portal-binding'"-->
<!--      ></span>-->
<!--    </el-tooltip>-->
<!--  </div>-->
</template>

<script>
export default {
  name: "colorPickerThemeColor",
  props: {
    color: {
      type: null, // 颜色有字符串和null的情况
      required: true
    },
    isThemeColor: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tooltipDelay: 1000
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor || "#3D82F2"
    },
    colorVal: {
      get() {
        return this.color
      },
      set(val) {
        // let newVal = val ? val : "rgba(255,255,255,0)"
        this.$emit("update:color", val)
        // this.$emit("change", {type: 'color', value: newVal})
      }
    },
    colorTypeVal: {
      get() {
        return this.colorType
      },
      set(val) {
        this.$emit("update:colorType", val)
        this.$emit("change", {type: 'colorType', value: val})
      }
    },
    isThemeColorVal: {
      get() {
        return this.isThemeColor
      },
      set(val) {
        this.$emit("update:isThemeColor", val)
        // this.$emit("change", {type: 'isThemeColor', value: val})
      }
    }
  },
  methods: {
    changeColorType() {
      this.isThemeColorVal = !this.isThemeColorVal
    },
    activeChangeColor(val) {
      this.colorVal = val
    }
  }
}
</script>

<style scoped>
.color-picker-container .color-text {
  width: calc(100% - 70px);
}
::v-deep .el-color-picker__mask {
  width: 20px;
  height: 20px;
  background-color: transparent;
}
::v-deep .el-color-picker.is-disabled .el-color-picker__color {
  border-radius: 50%;
  overflow: hidden;
}
</style>
